import React from 'react';
import { Alert, Button } from 'antd';

/**
 * Error boundary for Culture selection component
 * Catches errors during culture loading and provides user-friendly recovery
 */
class CultureErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[CultureErrorBoundary] Error caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Alert
          type="error"
          message="Erreur de chargement des cultures"
          description="Impossible de charger les cultures. Veuillez rafraichir la page ou reessayer."
          action={
            <Button size="small" onClick={this.handleRetry}>
              Reessayer
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default CultureErrorBoundary;
